import { AnyAction, ThunkDispatch } from "@reduxjs/toolkit";

import { setAlert } from "@lib/stores";
import { AlertType } from "@lib/stores/common/types";

interface ApiError {
  code: number;
  field: string;
  message: string;
}

export const thunkErrorHandler = async <T>(
  fn: () => Promise<T>,
  dispatch: ThunkDispatch<unknown, unknown, AnyAction>,
  rejectWithValue: (value: unknown) => any,
  errorTarget: "page" | "modal" = "page",
  errorMapper?: { [key: string]: string }
): Promise<T> => {
  try {
    return await fn();
  } catch (error: any) {
    const errors = error.response
      ? (JSON.parse(error.response.data).errors as ApiError[])
      : error.message
        ? ([{ code: 400, field: "", message: error.message }] as ApiError[])
        : undefined;

    const mappedErrors = errors?.map((e) => {
      if (errorMapper && errorMapper[e.message]) {
        return {
          ...e,
          message: errorMapper[e.message],
        };
      } else {
        return e;
      }
    });

    setAlert({
      show: true,
      for: errorTarget,
      type: AlertType.ERROR,
      messages: mappedErrors || [
        { code: 400, field: "", message: "Something went wrong" },
      ],
    });

    return rejectWithValue(errors);
  }
};
